import React, { createContext, useContext, type RefObject } from "react";

/**
 * Context used by floating UI (menus, submenus, tooltips) to determine
 * which element acts as the spatial boundary for fit/flip calculations.
 *
 * If provided, hooks/components can read this instead of requiring a
 * boundaryRef prop to be threaded through many layers.
 */
const FloatingBoundaryContext = createContext<RefObject<HTMLElement> | null>(null);

export type FloatingBoundaryProviderProps = {
  value: RefObject<HTMLElement>;
  children: React.ReactNode;
};

export function FloatingBoundaryProvider({ value, children }: FloatingBoundaryProviderProps): React.ReactElement {
  // Use React.createElement to avoid needing TSX in a .ts file
  return React.createElement(FloatingBoundaryContext.Provider, { value }, children as React.ReactElement);
}

export function useFloatingBoundary(): RefObject<HTMLElement> | null {
  return useContext(FloatingBoundaryContext);
}
